import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/store/state/app.state'
import { WebService } from '../api/web.service'
import { ServiceUrlConstants } from '../../constants/service-url-constants'
import { map } from 'rxjs'
import { FeedbackQuestionAPIModel, FeedbackResponseAPIModel } from '../../models/api.model'
import { update_feedback_ui_status } from '../../store/action/initialize.action'

@Injectable({
  providedIn: 'root'
})
export class FeedbackResponseService {
  constructor(private appState: Store<AppState>,private webservice: WebService,) {}

  fetchQuestionsFromTemplate(forType: string) {
    const endPoint = `${ServiceUrlConstants.API_FETCH_QUESTIONS_FROM_TEMPLATE}?forType=${forType}&latest=true`

    return this.webservice
      .get(endPoint)
      .pipe(
        map((data: FeedbackQuestionAPIModel[]) => data)
      )
  }

  saveFeedbackResponse(feedbackResponse: FeedbackResponseAPIModel) {
    const endPoint = `${ServiceUrlConstants.API_SAVE_FEEDBACK_RESPONSE}`

    return this.webservice
      .post(endPoint, feedbackResponse)
      .pipe(
        map((data: FeedbackResponseAPIModel) => data)
      )
  }

  dispatchUpdateFeedbackStateUiStatus(feedbackId: string) {
    this.appState.dispatch(update_feedback_ui_status({ feedbackId, newStatus: 'INTERACTED' }))
  }

  updateFeedbackStatus(feedbackId: string, newStatus: string) {
    const endPoint = `${ServiceUrlConstants.API_UPDATE_FEEDBACK_STATUS}/${feedbackId}/${newStatus}`
    return this.webservice.put(endPoint, null)
  }

}
